export const metaPath = '/meta'
export const menuPath = '/menu'
export const storeOrderPath = '/order'
export const userPath = '/user'
export const userFacebookPath = '/user/facebook'
export const unavailableResourcePath = '/unavailableResource'
export const getAccessTokenPath = '/oauth2/customer-access'
export const getOPAddressesPath = '/addresses'
